<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder">
        <PaymentForm class="form-horizontal">
          <FormSection title="" hide>
            <div>
              <AmountSelectorNyGalaDinner />
            </div>
          </FormSection>
          <FormSection title="Reservations" v-if="((form.amount && Number(form.amount) && Number(form.amount) > 249) || guestQty > 0)">
            <div class="reserved__bstns">
              <div class="radio-part">
                <input
                  id="type_attending"
                  name="Attending"
                  type="radio"
                  :checked="getValue('custom.AttendInPerson') == 'yes'"
                  @click="setValue('custom.AttendInPerson', 'yes')"
                />
                <FormLabel for="type_attending"> YES, WILL ATTEND </FormLabel>
              </div>
              <div class="radio-part">
                <input
                  name="Attending"
                  id="type_noattending"
                  type="radio"
                  :checked="getValue('custom.AttendInPerson') == 'no'"
                  @click="setValue('custom.AttendInPerson', 'no')"
                />
                <FormLabel for="type_noattending"> NO, WILL NOT ATTEND </FormLabel>
              </div>
            </div>
            <ErrorLabel field="custom.AttendInPerson" />
            <div v-if="getValue('custom.AttendInPerson') == 'yes'">
              <br />
              <FormRow>
                <div style="width:100%;max-width: 320px;margin:0 auto;">
                  <h2> How Many will attend? </h2>
                  <select style="margin: auto;" v-model="attending">
                    <option value="0">0</option>
                    <option v-for="index in Number(form.custom.ticketsQnt)" :key="index" :value="index">{{index}}</option>
                  </select>
                </div>
              </FormRow>
              <div v-if="attending">
                <h2>Attendee Names</h2>
                <FormRow v-for="index in attending" :key="index">
                  <div style="flex:1;margin-right: 10px">
                    <input
                      type="text"
                      :value="names[index - 1] ? names[index - 1] : null"
                      @change="setName(index - 1, $event.target.value)"
                    >
                  </div>
                </FormRow>
              </div>
            </div>
          </FormSection>
          <FormSection title="contribution designation" v-if="form.amount && Number(form.amount) && Number(form.amount) > 5">
            <div>
              <FormRow
                class="designation-form-row"
                v-for="(item, index) in designations"
                :key="index"
              >
                <label :for="'designation_' + index" class="pre-dinner__label">
                  <input
                    type="checkbox"
                    :id="'designation_' + index"
                    :value="item.value"
                    class="pre-dinner__checkbox pre-dinner__designations"
                    :checked="checkedDesignations.includes(item.value)"
                    @click="toggleDesignation(item.value, $event.target.checked)"
                    ref="index === designations.length - 1 ? otherCheckbox : null"
                  />
                  <span class="pre-dinner__text">{{ item.label }}</span>
                </label>
                <FormRow
                  v-if="
                    index === designations.length - 1 &&
                    checkedDesignations.includes(item.value)
                  "
                  class="full-width"
                >
                  <div style="width: 100%">
                    <FormLabel class="control-label"> In honor of: </FormLabel>
                    <input
                      type="text"
                      class="width-full"
                      v-model="honorOf"
                      ref="otherTextInput"
                    />
                  </div>
                </FormRow>
              </FormRow>
            </div>
          </FormSection>
          <FormSection title="Notes" v-if="form.amount && Number(form.amount) && Number(form.amount) < 251">
            <FormRow>
              <FormInput type="textarea" class="width-full" field="custom.extras" />
            </FormRow>
          </FormSection>
          <FormSection title="E-Journal Message" v-if="form.amount && Number(form.amount) && Number(form.amount) > 249">
            <FormRow>
              <FormInput type="textarea" class="width-full" field="custom.Notes" />
            </FormRow>
          </FormSection>
   
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
                      <Consent privacy="https://www.yachad.org/privacy-policy/"/>
                  </FormRow>
          </FormSection>
          <FormSection title="Contact Info">
            <DonorAddress />
          </FormSection>
          <FormSection title="Payment Info" last>
            <!-- <p class="payment-info__tax-note">Your contribution is tax deductible except for $100 per person attending the dinner <br><i>(in accordance with Federal Law).</i></p> -->
            <div class="payment-info">
              <FormRow>
                <PaymentType cc_text="Credit Card" check_text="Check" />
              </FormRow>
              <FormRow inline>
                <FormCol
                  class="doublepay"
                  field="card"
                  :showLabel="false"
                  check_text=""
                />
              </FormRow>
              <FormRow
                v-if="form.gateway === 'check'"
                style="justify-content: center;gap: 20px;align-items: start;"
                class="checktext"
              >
                <div style="padding-bottom:15px;">
                  Please mail your check to the following address:
                  <p style="text-align: center">
                    <strong
                      >Yachad Gala<br />
                      C/O Rebecca Shatz<br />
                       40 Rector St<br />4th Floor New York
                       <br />NY 10006</strong
                    >
                  </p>
                </div>
              </FormRow>
            </div>
          </FormSection>
          <PaymentButton showAmount btnText="Pay now" />

        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { onMounted } from "vue";
import { defineComponent, watch, ref } from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";
import AmountSelectorNyGalaDinner from "./amount-selector-njgala-dinner.vue";

export default defineComponent({
  components: {
    AmountSelectorNyGalaDinner,
  },
  props: {
    subCampaign: String,
    campaign: String,
  },
  setup(props) {
    const { setValue, form, getValue, submit } = usePaymentForm();

    const otherCheckbox = ref<HTMLInputElement | null>(null);
    const otherTextInput = ref<HTMLInputElement | null>(null);

    const honoOtherrOf = ref("");
    const honorOf = ref("");
    const attending = ref()
    const names = ref<string[]>([])

    var guestQty = ref(0);


    watch(
      () => getValue("custom.ticketsQnt"),
      (val) => {
        if (val) {
          guestQty.value = Number(getValue("custom.ticketsQnt"));
        }
      }
    );

    const designations = [
      { label: "The Goldstein Family - Yachad Family Award", value: "The Goldstein Family - Yachad Family Award" },
      { label: "Jeremy Joszef, Director and the Wahrhaftig Family - Celebrating 25 years of Yachad at Camp Morasha", value: "Jeremy Joszef, Director and the Wahrhaftig Family - Celebrating 25 years of Yachad at Camp Morasha" },
      { label: "Duvi Taub, White Glove Consulting - The Lev Business Award", value: "Duvi Taub, White Glove Consulting - The Lev Business Award" },
      { label: "High School Seniors Leadership Award", value: "High School Seniors Leadership Award" },
      { label: "Other", value: "Other" },
    ];
    let checkedDesignations = ref<string[]>([]);
    const firstCheckbox = ref<HTMLInputElement | null>(null);
    const honoreesDesignation = ref("");

    const toggleDesignation = (value: string, checked: boolean) => {
      if (checked) {
        if (!checkedDesignations.value.includes(value)) {
          checkedDesignations.value.push(value);
        }
      } else {
        checkedDesignations.value = checkedDesignations.value.filter(v => v !== value);
      }
    };

    watch(checkedDesignations, () => {
      let tempArray = [];
      let honorString = honorOf.value + checkedDesignations.value;
      tempArray = honorString.split(",")
      const index = tempArray.indexOf("Other");
      if (index > -1) {
        tempArray.splice(index, 1);
        //@ts-ignore
        setValue("custom.honorOf", tempArray);
      } else {
        //@ts-ignore
        setValue("custom.honorOf", checkedDesignations.value);
      }
    });

    watch(honorOf, () => {
      let tempArray = [];
      let honorString = honorOf.value + checkedDesignations.value;
      tempArray = honorString.split(",")
      const index = tempArray.indexOf("Other");
      if (index > -1) {
        tempArray.splice(index, 1);
        //@ts-ignore
        setValue("custom.honorOf", tempArray);
      } else {
        //@ts-ignore
        setValue("custom.honorOf", checkedDesignations.value);
      }
    })

    function setName(index: any, value:String) {
      const nextValue: String = value
      names.value[index] = nextValue;
      setValue('custom.guests', names.value.toString());
    }

    if (props.subCampaign) {
      setValue("applications.0.subCampaign", props.subCampaign);
    }

    if (props.campaign) {
      setValue("applications.0.campaign", props.campaign);
    }

    onMounted(() => {
      const params = queryParams();

      if (params.utm_content) {
        if (
          !["Direct Mail", "Telemarketing", "Text SMS Message"].includes(
            params.utm_content
          )
        ) {
          throw new Error("Invalid subcampaign");
        }

        setValue("applications.0.subCampaign", params.utm_content);
      }
    });

    return {
      form,
      honoOtherrOf,
      designations,
      checkedDesignations,
      toggleDesignation,
      firstCheckbox,
      honoreesDesignation,
      otherTextInput,
      otherCheckbox,
      honorOf,
      attending,
      setValue,
      getValue,
      setName,
      submit,
      names,
      guestQty
    };
  },
});
</script>
<style scoped lang="scss">
::v-deep .form-container.ou-donation-form {
  position: relative;
}
.form-container.ou-donation-form {
  margin: 0px auto;
  padding: 10px;
  box-shadow: none;
  max-width: 750px;
}
::v-deep h2 {
  font-weight: 600;
  margin-bottom: 20px;
  margin-top: 40px;
  font-size: 20px;
  text-transform: uppercase;
  text-align: center;
  color: black;
}
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
::v-deep .note {
  font-style: italic;
  padding-top: 8px;
  line-height: 1.4;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  a {
    text-decoration: none;
  }
}
::v-deep .amount-row {
  min-width: 50% !important;
  max-width: 50% !important;
  margin-bottom: 0px;
  border: 2px solid rgba(243, 235, 207, 1);
  padding: 3px;

  @media (min-width: 720px) {
    min-width: 25% !important;
    max-width: 25% !important;
  }
  input[type="radio"],
  input[type="checkbox"] {
    height: 0;
    top: 20px;
    position: absolute;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  justify-content: center;

  label {
    font-weight: 500;
    padding: 22px 0px;
    border: none;
    background: white !important;
    color: #131232 !important;
    display: flex !important;
    line-height: normal;
    margin-bottom: 0px;
    &:hover {
      background: radial-gradient(
        ellipse at center,
        rgba(249, 246, 233, 1) 0%,
        rgba(255, 255, 255, 1) 5%,
        rgba(241, 232, 199, 1) 100%
      ) !important;
    }
  }
  input[type="radio"]:checked + label,
  input[type="checkbox"]:checked + label {
    background: radial-gradient(
      ellipse at center,
      rgba(249, 246, 233, 1) 0%,
      rgba(255, 255, 255, 1) 5%,
      rgba(241, 232, 199, 1) 100%
    ) !important;
  }

  textarea {
    padding: 5px 10px;
    font-family: inherit;
  }
  ::v-deep .label-description {
    background: none !important;
    display: block !important;
    text-align: center !important;
    font-size: 15px;
    font-style: italic;
    padding-top: 0;
  }
  .label-amount {
    background: none !important;
    display: inline-block !important;
    height: auto !important;
    max-width: 100%;
    text-align: center;
    color: rgba(175, 155, 83, 1);
    font-weight: 600;
    font-size: 18px;
    padding-bottom: 10px;
    margin-bottom: 7px;
    -o-border-image: url("https://res.cloudinary.com/orthodox-union/image/upload/f_auto,q_auto/v1503564922/NCSY/Rectangle-border.png")
      27 fill repeat;
    border-image: url("https://res.cloudinary.com/orthodox-union/image/upload/f_auto,q_auto/v1503564922/NCSY/Rectangle-border.png")
      27 fill repeat;
    border-style: solid;
    border-width: 0px 0px 1px 0px;
  }
  #amount_other {
    max-width: 100%;
  }
  .amount_other__wrapper::before {
    background: #0c3450 !important;
    color: white !important;
    font-weight: bold;
  }
  .amount_other__wrapper {
    margin-bottom: 18px;
  }
}

.radio-part {
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 5px;
}
::v-deep label {
  line-height: normal !important;
}
.radio-part label {
  margin: 0px;
  padding: 0px;
  line-height: normal;
}

::v-deep .reserved__bstns {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  .radio-part {
    min-width: 50% !important;
    max-width: 50% !important;
    border: 2px solid #f3ebcf;
    padding: 3px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;

    label {
      margin: 0px;
      padding: 13px;
      cursor: pointer;
      line-height: normal;
      width: 100%;
      text-align: center;
      /* font-weight: 600; */
      font-size: 17px;
      display: block;
      color: #131232;
      text-transform: capitalize;
      letter-spacing: 2px;
    }
    input[type="radio"],
  input[type="checkbox"] {
      height: 0;
      top: 20px;
      position: absolute;
      left: 20px;
      z-index: -1;
      visibility: hidden;
    }
    label:hover {
      background: radial-gradient(
        ellipse at center,
        #f9f6e9 0%,
        white 5%,
        #f1e8c7 100%
      ) !important;
    }
    input[type="radio"]:checked + label,
    input[type="checkbox"]:checked + label {
      background: radial-gradient(
        ellipse at center,
        #f9f6e9 0%,
        white 5%,
        #f1e8c7 100%
      ) !important;
    }
  }
}

::v-deep .payment-info {
  // display: flex;
  // flex-flow: column;
  // align-items: center;
  // justify-content: center;
}
::v-deep .payment {
  display: flex;
  align-items: center;
  flex-flow: column;
  justify-content: center;
}
::v-deep hr {
  background: none;
  box-shadow: none;
  height: 0;
  border: none;
  border-bottom: 1px solid #efefef;
}
::v-deep label.control-label {
  flex: 1;
  max-width: 100%;
  padding-top: 3px;
  padding-bottom: 3px;
  display: block;
  font-size: 14px;
  color: #222;
  font-weight: 400;
  text-transform: none;
  text-align: left;
  font-family: inherit;
  letter-spacing: 0px;
}

::v-deep h1 {
  padding-bottom: 0px;
  &:after {
    content: none;
    margin: 0px;
    padding: 0px;
  }
}



.payment-info ::v-deep .styled-radio-container--ou-donation.styled-radio-container {
  justify-content: center;
  .radio-part {
    min-width: 200px;
  }
  label {
    border: 2px solid #ddd;
    background: white;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 2px;
    font-weight: normal;
  }
  input[type='radio']:checked + label {
    background: radial-gradient(
        ellipse at center,
        #f9f6e9 0%,
        white 5%,
        #f1e8c7 100%
      ) !important;
    color: #141233;
  }
  label:hover {
    background: #f7f9fb;
  }
}

::v-deep .error-label {
  text-align: center;
}
.amex__notificion{
  font-style: italic;
    margin-bottom: 19px;
    font-size: 15px;
    margin-top: -7px;
}

.checktext {
  margin-top: -20px;
  line-height: 21px;
  p {
    margin-top: 5px;
  }
}
.designation-form-row.form-group {text-transform: uppercase;font-weight: 400;letter-spacing: 2px;font-size: 13px;color: #333;margin-bottom: 10px;}

.designation-form-row.form-group input[type=checkbox] {
    width: 20px;
    height: 20px;
    margin-right: 3px;
    border-radius: 4px;
    border: 2px solid #e8e2e1;
    background: #fff;
}

span.pre-dinner__text {
    display: block;
    line-height: normal;
    text-align: left;
    flex: 1;
}

.pre-dinner__label {
    display: flex;
    gap: 6px;
    align-items: center;
}
.designation-form-row.form-group {
    flex-flow: wrap;
}
.designation-form-row.form-group .full-width.form-group {
    min-width: 100%;
    max-width: 100%;
    padding-top: 10px;
}


::v-deep .label__consent {
  text-align: left;
  text-transform: none;
}
p.payment-info__tax-note {
    margin-bottom: 14px;
    font-size: 14px;
}
</style>
